import React, { useState } from "react";
import "../styles/teamNoteCard.css";

export default function TeamNoteCard({ id, logo, short_name, title, date, text, onDelete }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="saved-note-card">

            <div className="saved-note-header" onClick={() => setOpen(open ? false : true)}>

                <div className="note-left">

                    {/* LOGO ÉS TITLE */}
                    <div className="note-logo"><img src={`/images/teams/${logo}`} alt={short_name} /></div>
                    <span className="saved-note-title">{title}</span>

                </div>

                <div className="saved-note-actions">

                    <span className="saved-note-date">{date}</span>

                    <button
                        className="delete-note-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete(id)
                        }}
                        title="Jegyzet törlése"
                    >
                        <i class="bi bi-trash3"></i>
                    </button>

                </div>
            </div>

            <div className="note-card-body">
                <p className={`saved-note-text ${open ? "expanded" : "collapsed"}`}>
                    {text}
                </p>

                {/* EGYETLEN gomb, nincs wrapper */}
                <button
                    className="note-toggle-btn"
                    onClick={() => setOpen(!open)}
                    title={open ? "Bezárás" : "Megnyitás"}
                >
                    {open ? <i class="bi bi-arrow-up"></i> : <i class="bi bi-arrow-down"></i>}
                </button>
            </div>
        </div>
    );
}
